module.exports = __webpack_public_path__ + "img/my_blue.7c769018.svg";